import { CalendarComponentOptions } from 'ion2-calendar';
import { FaturaDetayGosterPage } from './../faturaislemleri/fatura-detay-goster/fatura-detay-goster';
import { NakliyeFaturaGirisPage } from './../nakliye-fatura-giris/nakliye-fatura-giris';
import { BllOrtak } from './../../providers/bll/bll-ortak';
import { Ortak } from './../../providers/ortak';
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ActionSheetController, ModalController } from 'ionic-angular';
declare var cordova: any;
/**
 * Generated class for the NakliyeFaturaListesiPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-nakliye-fatura-listesi',
  templateUrl: 'nakliye-fatura-listesi.html',
})
export class NakliyeFaturaListesiPage {
  @ViewChild('sideNavUrunAra') sideNav;
  faturaListesi = [];
  aranan = "";
  take: number = 50;
  ServerParamet: any = { FirmaAdi: "", FirmaTelefonu: "", FirmaAdres: "", FirmaEmail: "", FirmaWeb: "", FirmaVD: "", FirmaVN: "" };
  pdfdetaydata=[];
  tarih1: any;
  tarih2: any;
  dateRange: {
    from: Date
    to: Date
  } = {
      from: this.tarih1,
      to: this.tarih2
    };
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  optionsRange: CalendarComponentOptions = {
    from: new Date(2016, 1, 1),
    pickMode: 'range',
    color: "danger",
    monthPickerFormat: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Tem", "Agust", "Eylül", "Ekim", "Kasım", "Aralık"]
  };
  constructor(public navCtrl: NavController,
    public ortak: Ortak,
    public bllOrtak: BllOrtak,
    public actionSheetCtrl:ActionSheetController,
    public modalCtrl:ModalController,
    public navParams: NavParams) {
      var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
      var localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0,-1);
          this.tarih1 = this.ortak.tarih(this.ortak.storageGunTarihiGetir);
          this.tarih2 = localISOTime;
      this.bllOrtak.islemWithoutPost("ParametreleriVer", "", false).then(a => {
        var sonuc = <any>a;
        this.ServerParamet = sonuc.SonucObject;
      });
  }

  ionViewDidLoad() {
    this.dateRange.from = this.ortak.storageGunTarihiGetir;
    this.dateRange.to = this.ortak.storageGunTarihiGetir;
    this.FaturaAra();
    this.closeNav();
  }
  faturalar(e){
    if(e.keyCode==13)
    {
      this.FaturaAra();
    }
  }
 
  FaturaAra() {
    var formData = new FormData();
     formData.append("aranan", this.aranan);
    // formData.append("take", this.take.toString());
    formData.append("tarih1", this.tarih1);
    formData.append("tarih2",this.tarih2);
  


    console.log("t1",this.ortak.tarih(this.dateRange.from));
    
    console.log("t2",this.ortak.tarih(this.dateRange.to));
    this.bllOrtak.islem(formData, "NakliyeFaturalari", "Faturalar Getiriliyor,Lütfen Bekleyiniz..", false).then(a => {
      var sonuc = <any>a;
   this.faturaListesi = sonuc.SonucObject;

     
   this.closeNav();
    }).catch(x => {
      console.log(x);
    })
  }
  openNav() {
    let sideElement = this.sideNav.nativeElement
    sideElement.style.display = "block";
  }
  closeNav() {
    let sideElement = this.sideNav.nativeElement;
    sideElement.style.display = "none";
  }
  Islemler(fatura) {
    const actionSheet = this.actionSheetCtrl.create({
      title: 'Fatura  İşlemleri',
      buttons: [
        {
          text: 'Faturayı Sil',
  
          handler:()=>{
     this.FaturaSil(fatura);
          }
         
        },
        {
          text: 'Pdf Yazdır',
  
          handler:()=>{
            this.pdfdetaylari(fatura);
          }
         
        },
        {
          text: 'Fatura Detayları',
  
          handler:()=>{
            this.faturaDetaylari(fatura);
          }
         
        },
        {
          text: 'İptal ',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }

  YeniFatura()
  {   this.navCtrl.push(NakliyeFaturaGirisPage);
    // let modal=this.modalCtrl.create(AlisFaturalariPage);
    // modal.onDidDismiss(data => {
    //   this.ionViewDidLoad();
    // });

    // modal.present();
    this.ionViewDidLoad();
  }

  FaturaSil(fatura)
  {
    this.ortak.showConfirmAlert("Uyarı","Fatura Silinecek Devam Etmek İstiyormusunuz?.").then(a=>{
      var fordata=new FormData();
      fordata.append("belgeno",fatura.IslemCode);
      this.bllOrtak.islem(fordata,"FaturaSil","",true).then(a=>{
        var sonuc=<any>a;
        if(sonuc.Sonuc==1)this.ortak.showBasicAlert("Başarılı","Fatura Silindi.");
        this.FaturaAra();
        if(sonuc.Sonuc!=1)this.ortak.showBasicAlert("Hata","Beklenmedik bir hata oluştu..");
      })
    })
  
  }
  faturaDetaylari(fatura)
  {
    let modal = this.modalCtrl.create(FaturaDetayGosterPage,{belgeno:fatura.IslemCode});
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });

    modal.present();
  }
  pdfdetaylari(fatura)
  {
    var formdata = new FormData();
    formdata.append("islemcode", fatura.IslemCode);
    this.bllOrtak.islem(formdata, "FaturaPdfDetay", "", true).then(a => {
      var sonuc = <any>a;
      this.pdfdetaydata = sonuc.SonucObject;
      if(this.pdfdetaydata!=null)
      {
        this.pdfMake(fatura);
      }
    
    });
  }
  pdfMake(fatura) {

    var html = "<html><head>  <link href='https://stackpath.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css' rel='stylesheet'></head><body>" +
      "<table style='width: 100%;border-bottom:1px solid lightgray;margin-bottom:30px'>" +
      "<tbody>" +
      "<tr>" +
      "<td style'width: 41.8357%;'>&nbsp;</td>" +
      "<td style='width: 53.1643%;'><span style='float:left;width:100%;text-align:right'>"+this.ServerParamet.FirmaAdres+"</span></td>" +
      "</tr>" +
      "<tr>" +
      "<td style='width: 41.8357%;'>&nbsp;<span style='color: #cc0000;'><strong style='font-size: 30px;'><strong>"+this.ServerParamet.FirmaAdi+"</strong></strong></span></td>" +
      "<td style='width: 53.1643%;'><span style='float:left;width:100%;text-align:right'>"+this.ServerParamet.FirmaTelefonu+"</span></td>" +
      "</tr>" +
      "<tr>" +
      "<td style='width: 41.8357%;'>&nbsp;</td>" +
      "<td style='width: 53.1643%;'><span style='float:left;width:100%;text-align:right'>"+this.ServerParamet.FirmaWeb+"</span></td>" +
      "</tr>" +
      "</tbody>" +
      "</table>" +
      "<div style='float:right;width:100%'>Cari Hesap Adı:<strong>" + fatura.CariAdi + "</strong></div>" +
      "<div style='float:right;width:100%'>Fatura No:<strong>" + fatura.IslemCode + "</strong></div>" +
      "<div style='float:right;width:100%;margin:bottom:20px'>Fatura Tarihi:<strong>" + this.ortak.tarih2(fatura.IslemTarihi)+ "</strong></div>" +
      "<div class='card text-center'>" +
      "<div class='card-footer text-muted'>" +
      "Alış Faturası" +
      "</div>" +
      "</div><hr/>" +
      "<table class='table table-striped table-bordered table-hover'>" +
      "<thead>" +
      "<tr>" +
      "<th>Stok Adı</th>" +
      "<th>Miktar</th>" +
      "<th>B.Fiyat</th>" +
      "<th>Toplam</th>" +
      "</tr>" +
      "</thead>" +
      "<tbody>";
    this.pdfdetaydata.forEach(extre => {
      html = html + "<tr>";
      html = html + "<td>" + extre.StokAdi + "</td>";
      html = html + "<td>" + extre.Miktar + "</td>";
      html = html + "<td>" + extre.BirimFiyat+ "</td>";
      html = html + "<td>" + extre.Tutar.toFixed(2) + "</td>";
      html = html + "</tr>";
      
    });
    html = html + "<table style='width:100%'>";
    html = html + "<tr>";
    html = html + "<td>";
    html = html + "<span style='float:left;width:100%;text-align:right'>Genel Toplam: " + fatura.Tutar.toFixed(2) + " </span>";
    html = html + "</td>";
    html = html + "</tr>";
    html = html + "</table>";
    html = html + "</body></html>";
    html = html + "</tbody></table></body></html>";
    cordova.plugins.pdf.htmlToPDF({
      data: html,
      documentSize: "A4",
      landscape: "portrait",
      type: "share"
    },
      (sucess) => console.log('sucess: ', sucess),
      (error) => console.log('error:', error));
  }
}



// WEBPACK FOOTER //
// ./src/pages/nakliye-fatura-listesi/nakliye-fatura-listesi.ts